import { PROFILE_FORM_STYLES } from "@/components/Forms/profile-form-styles";
import { cn } from "@/lib/utils";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import type { useCredentialVaultEditor } from "./use-credential-vault-editor";

export function ProviderCredentialConfirmationDialogs({
  editor,
  credentialLabel,
  onDiscard,
}: {
  editor: ReturnType<typeof useCredentialVaultEditor>;
  credentialLabel: string;
  onDiscard: () => void;
}) {
  const {
    showDiscardWarning,
    setShowDiscardWarning,
    showRemoveWarning,
    setShowRemoveWarning,
    isPending,
    removeCredential,
  } = editor;
  return (
    <>
      <AlertDialog
        open={showDiscardWarning}
        onOpenChange={setShowDiscardWarning}
      >
        <AlertDialogContent className={PROFILE_FORM_STYLES.confirmation}>
          <AlertDialogHeader className="text-left">
            <AlertDialogTitle className={PROFILE_FORM_STYLES.title}>
              Discard your changes?
            </AlertDialogTitle>
            <AlertDialogDescription className={PROFILE_FORM_STYLES.description}>
              Your changes to this credential have not been saved.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter className="mt-2 gap-3 sm:space-x-0">
            <AlertDialogCancel
              className={cn(PROFILE_FORM_STYLES.secondaryButton, "mt-0")}
            >
              Keep editing
            </AlertDialogCancel>
            <AlertDialogAction
              className={PROFILE_FORM_STYLES.dangerButton}
              onClick={onDiscard}
            >
              Discard changes
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
      <AlertDialog
        open={showRemoveWarning}
        onOpenChange={(open) => {
          if (!isPending) {
            setShowRemoveWarning(open);
          }
        }}
      >
        <AlertDialogContent className={PROFILE_FORM_STYLES.confirmation}>
          <AlertDialogHeader className="text-left">
            <AlertDialogTitle className={PROFILE_FORM_STYLES.title}>
              Remove {credentialLabel}?
            </AlertDialogTitle>
            <AlertDialogDescription className={PROFILE_FORM_STYLES.description}>
              This credential and its supporting documents will be removed from
              this credential record. Its history will be kept.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter className="mt-2 gap-3 sm:space-x-0">
            <AlertDialogCancel
              className={cn(PROFILE_FORM_STYLES.secondaryButton, "mt-0")}
              disabled={isPending}
            >
              Cancel
            </AlertDialogCancel>
            <AlertDialogAction
              className={PROFILE_FORM_STYLES.dangerButton}
              disabled={isPending}
              onClick={(event) => {
                event.preventDefault();
                void removeCredential();
              }}
            >
              {isPending ? "Removing…" : "Remove credential"}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
}
